module.exports = __webpack_public_path__ + "img/首图中文.d59b7931.png";